import Fetcher from '../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../constants'
import {
  AddHealthSystemRequest,
  AddHealthSystemResponse,
  AddHSToCCRequest
} from './types'

const fetcher = new Fetcher({})

export const getHSList = async (id, data) =>
  fetcher.request<AddHealthSystemRequest, AddHealthSystemResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.CATEGORIES}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HEALTH_SYSTEM}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const addHSToCC = (id, data, successMessage) =>
  fetcher.request<AddHSToCCRequest, AddHealthSystemResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.CATEGORIES}${id}/${API_DICTIONARY.FACILITIES}`,
    method: HTTP_METHODS.POST,
    data,
    successMessage
  })
